<template>
    <v-card class="elevation-10">
        <v-card-title>
            <h2>Orders confirmations pendings</h2>
        </v-card-title>
        <OrderTable></OrderTable>
        <v-card-title>
            <h2>Sample request in preparation</h2>
        </v-card-title>
        <SampleOrderTable></SampleOrderTable>
    </v-card>
</template>

<script>
    import OrderTable from './Components/OrdersTable';
    import SampleOrderTable from './Components/SampleOrdersTable';

    export default {
        components: {
            OrderTable,
            SampleOrderTable
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/home/HomeComponent.vue